import React from 'react'
import Moment from 'react-moment'
import { pascal } from 'change-case'
import { StatusTag, DivText } from './styled'
import { IconButton, Tooltip } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import { getOptionTitle } from 'core/utilities'
import styled from '@emotion/styled'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

// import r from 'reactotron-react-js'

const ActionButtonContainer = styled.div({
  display: 'flex', 
  button: { 
    span: { 
      'svg.MuiSvgIcon-root': { 
        fontSize: '1.1rem',
      } 
    }
  }
})

export const options = {
  listSize: [
    { text: '30', value: 30 },
    { text: '60', value: 60 },
    { text: '90', value: 90 },
    { text: '120', value: 120 }
  ],
  purpose: [
    { text: 'Create', value: 'create' },
    { text: 'Change', value: 'change' },
    { text: 'Copy Company/Purchasing Org', value: 'copy' },
    { text: 'Block', value: 'block' }
  ],
  vendorType: [
    { text: 'Personal', value: 'personal' },
    { text: 'Legal Entity/Company', value: 'company' },
  ],
  paymentType: [
    { text: 'Transfer', value: 'transfer' },
    { text: 'Cheque', value: 'cheque' },
    { text: 'T/T, L/C', value: 'ttlc'}
  ]
}

export const columnUser = (props) => {
  const { withActions, showUserModal, onDeleteUser } = props

  return ([
    {
      Header: 'Action',
      accessor: '',
      show: withActions,
      width: 100,
      Cell: row => (
        <ActionButtonContainer>
          <Tooltip title='Edit'>
            <IconButton onClick={() => showUserModal(row.index)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteUser(row.index)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </ActionButtonContainer>
      )
    }, {
      Header: 'Firstname',
      accessor: 'firstname',
    }, {
      Header: 'Lastname',
      accessor: 'lastname',
    }, {
      Header: 'Email',
      accessor: 'email',
    }, {
      Header: 'Mobile',
      accessor: 'mobile',
      width: 100,
    }, {
      Header: 'Telephone',
      accessor: 'telephone',
      width: 100,
    }, {
      Header: 'Extension',
      accessor: 'extension',
      width: 80,
    }, {
      Header: 'Register EzProcure',
      accessor: 'registerEzProcure',
      width: 110,
      Cell: row => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {row.value ? <Icon color='green' icon='check' /> : ''}
        </div>
      )
    }
    , {
      Header: 'Receive Payment Notification',
      accessor: 'receiveChequeAtBank',
      width: 110,
      Cell: row => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {row.value ? <Icon color='green' icon='check' /> : ''}
        </div>
      )
    }
    // , {
    //   Header: 'Allow Accept PO',
    //   accessor: 'allowAcceptPo',
    //   width: 110,
    //   Cell: row => (
    //     <div style={{ display: 'flex', justifyContent: 'center' }}>
    //       {row.value === true ? 'Yes' : ''}
    //     </div>
    //   )
    // }
  ])
}

export const columnBank = (props) => {
  const { withActions, showBankModal, onDeleteBank, countryOptions, bankKeyOptions,
    bankBranchOptions, getBankBranch } = props

  const getBankBranchTitle = (data) => {
    const { bankKey, branch } = data

    if (bankBranchOptions.data[bankKey] === undefined) {
      getBankBranch(bankKey)
      return branch
    } else {
      const listBranch = bankBranchOptions.data[bankKey] 
      return getOptionTitle(listBranch, branch)
    }
  }

  return ([
    {
      Header: 'Action',
      accessor: '',
      show: withActions,
      width: 100,
      Cell: row => (
        <ActionButtonContainer>
          <Tooltip title='Edit'>
            <IconButton onClick={() => showBankModal(row.index)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteBank(row.index)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </ActionButtonContainer>
      )
    }, {
      Header: 'Bank Country',
      accessor: 'bankCountry',
      Cell: row => (getOptionTitle(countryOptions, row.value))
    }, {
      Header: 'Bank Key',
      accessor: 'bankKey',
      Cell: row => (getOptionTitle(bankKeyOptions, row.value))
    }, {
      Header: 'Branch',
      accessor: 'branch',
      Cell: row => getBankBranchTitle(row.original)
    }, {
      Header: 'Account Number',
      accessor: 'accountNumber',
    }, {
      Header: 'Account Name',
      accessor: 'accountName',
    }
  ])
}

export const columns = {
  list: [
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell: row => (<DivText><StatusTag status={row.value}>{row.original.statusName}</StatusTag></DivText>)
    }, {
      Header: 'Doc No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
      width: 250
    }, {
      Header: () => (<DivText left>Purpose</DivText>),
      accessor: 'purpose',
      width: 100,
      Cell: row => pascal(row.value)
    }, {
      Header: 'Vendor',
      accessor: 'vendor',
      width: 100,
    }, {
      Header: 'Company',
      accessor: 'company',
      width: 100,
    }, {
      Header: 'Current Activity',
      accessor: 'statusActivity',
      width: 70,
    }, {
      Header: () => (<DivText left>Requester</DivText>),
      accessor: 'requester',
      width: 100,
      Cell: row => (row.value && <DivText left>{`${row.value || '-'}`}</DivText>)
    }, 
    {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ]
}

export const columnWht = (props) => {
  const { withActions, showWhtModal, onDeleteWht, whtTypeOptions, whtReceiptTypeOptions } = props

  return ([
    {
      Header: 'Action',
      accessor: '',
      show: withActions,
      width: 120,
      Cell: row => (
        <div style={{ display: 'flex' }}>
          <Tooltip title='Edit'>
            <IconButton onClick={() => showWhtModal(row.index)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteWht(row.index)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </div>
      )
    }, {
      Header: 'Withholding Tax Type',
      accessor: 'whtTypeCode',
      Cell: row => (getOptionTitle(whtTypeOptions, row.value))
    }, {
      Header: 'Receipt Type',
      accessor: 'whtReceiptTypes',
      Cell: row => (getOptionTitle(whtReceiptTypeOptions, row.value))
    }, {
      Header: 'Subject',
      accessor: 'subject',
      Cell: row => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {row.value ? <Icon color='green' icon='check' /> : ''}
        </div>
      )
    }
  ])
}

export const columnBranch = (props) => {
  const { withActions, showBranchModal, onDeleteBranch } = props

  return ([
    {
      Header: 'Action',
      accessor: '',
      show: withActions,
      width: 120,
      Cell: row => (
        <div style={{ display: 'flex' }}>
          <Tooltip title='Edit'>
            <IconButton onClick={() => showBranchModal(row.index)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteBranch(row.index)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </div>
      )
    }, {
      Header: 'Branch Code',
      accessor: 'branchCode'
    }, {
      Header: 'Description',
      accessor: 'description'
    }, {
      Header: 'Default Branch',
      accessor: 'defaultBranch',
      Cell: row => (row.value ? <Icon color='green' icon='check' /> : '')
    }
  ])
}

// export const documentTypes = [
//   { name: 'ภพ.20 or ภพ.09', code: 'VMA01', require: false },
//   { name: 'หนังสือรับรอง (ไม่เกิน 3 เดือน)', code: 'VMA02', require: false },
//   { name: 'หนังสือจดทะเบียนสมาคม/มูลนิธิ', code: 'VMA03', require: false },
//   { name: 'เลขบัญชีธนาคาร (กรณีโอนเงิน)', code: 'VMA04', require: false },
//   { name: 'สำเนาบัตรประจำตัวประชาชน (บุคคลธรรมดา)', code: 'VMA05', require: false },
//   { name: 'หนังสือข้อตกลงในการทำธุรกรรมทางอิเล็กทรอนิกส์ ', code: 'VMA06', require: false },
//   { name: 'หนังสือยินยอมให้ชำระค่าสินค้า และ/หรือ บริการผ่านบัญชีธนาคาร', code: 'VMA07', require: false },
//   { name: 'Profoma Invoice', code: 'VMA08', require: false }
// ]

export const checkAttachmentRequire = (docType, valueForm) => {
  const { paymentTypeTransfer, vendorType, vendorUsers, accountGroup } = valueForm
  const { code, isRequire } = docType

  if ((code === 'VMA01' || code === 'VMA02')) {
    if (vendorType === 'personal') {
      return false
    } else {
      if (accountGroup === 'ZDOV' || accountGroup === 'ZOTV') {
        return true
      }
    }
  }
  
  if (code === 'VMA03' && accountGroup === 'ZDNT' && vendorType === 'personal') {
    return false
  }

  if (code === 'VMA04') {
    return paymentTypeTransfer
  }

  if (code === 'VMA05') {
    return vendorType && vendorType === 'personal'
  }

  if (code === 'VMA06') {
    var registerUsers = vendorUsers.filter(u => u.registerEzProcure === true) || []
    return registerUsers.length > 0
  }

  if (code === 'VMA07') {
    return paymentTypeTransfer
  }

  return isRequire
}